import React, { type RefObject, useRef, useEffect } from "react";

import { Heading } from "../../../../../../mads";
import { Responsive } from "../../../../../../mads/icons";

export type InterviewNowCTAEnticerProps = {
  text: string;
  icon?: React.ReactElement;
  onFirstImpression: () => void;
  hasLoggedImpression: RefObject<boolean>;
};

export const CTAEnticerBannerContent: React.FC<InterviewNowCTAEnticerProps> = ({
  text,
  icon,
  onFirstImpression,
  hasLoggedImpression,
}) => {
  const onFirstImpressionRef = useRef(onFirstImpression);

  useEffect(() => {
    if (!hasLoggedImpression.current) {
      hasLoggedImpression.current = true;
      onFirstImpressionRef?.current?.();
    }
  }, [hasLoggedImpression]);

  return (
    <>
      {icon || <Responsive aria-hidden size={"xs"} color={"#237EA3"} />}
      <Heading level={2} sx={{ color: "foreground" }}>
        {text}
      </Heading>
    </>
  );
};
